"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFieldByConfig = void 0;
var _commonFormFields = require("@ori/common-form-fields");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _TranslationKey = require("../models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
const renderFieldByConfig = ({
  name,
  config,
  initialValue,
  isDisabled,
  labelKey,
  placeholder,
  customPrefix,
  isMultiline = false,
  customErrors,
  customMaxWidth = '100%'
}) => {
  const isAvailable = config?.isAvailable && !config.validation?.isAddressMatchRequired;
  const fieldName = `${customPrefix ?? ''}${name}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
    name: fieldName,
    isDisabled: isDisabled,
    isMultiline: isMultiline,
    label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _constants.defaultTranslations[labelKey],
      id: _TranslationKey.TranslationKey[labelKey]
    }),
    initialValue: initialValue,
    customPlaceholder: placeholder,
    ...config,
    isMandatory: config?.validation?.isMandatory,
    isAvailable: isAvailable,
    customErrors: customErrors,
    customMaxWidth: customMaxWidth
  });
};
exports.renderFieldByConfig = renderFieldByConfig;
//# sourceMappingURL=getFieldByConfig.js.map